import styled, { css } from "styled-components";

import { ShipdaCurrentLanguage } from "@sellernote/shared/src/i18n/i18nForShipda";
import { COLOR } from "@sellernote/ui/src/sds-v1/styles/constants";
import { setFontStyle } from "@sellernote/ui/src/sds-v1/styles/typography";
import { mobile } from "@sellernote/ui/src/styles/functions";

const container = styled.main`
  ${mobile(css`
    padding: 0 8px 40px 8px;
    background-color: ${COLOR.white};
    border-top: 1px solid ${COLOR.grayScale_200};
  `)}

  h3 {
    ${setFontStyle("Head5", "Bold")};
    color: ${COLOR.grayScale_800};
    padding: 24px 8.5px 16px 8.5px;
    border-bottom: 1px solid ${COLOR.grayScale_200};

    ${mobile(css`
      ${setFontStyle("Head6", "Bold")};
      border-bottom: 0;
    `)}
  }

  .annotation {
    margin-top: 16px;
    padding: 8px 16px;
    ${setFontStyle("SubHead3", "Bold")};
    color: ${COLOR.grayScale_700};
    background-color: ${COLOR.primaryBlue_10};
    border-radius: 5px;

    ${mobile(css`
      margin-top: ${ShipdaCurrentLanguage.currentLanguage === "en" ? 16 : 0}px;
    `)}
  }

  .desc {
    padding: 16px 16.5px 24px 16.5px;
    ${setFontStyle("Body7")};
    color: ${COLOR.grayScale_800};

    ${mobile(css`
      padding: 8px;
    `)}

    img {
      margin: 16px 0;
    }

    strong {
      ${setFontStyle("Body7", "Bold")};
    }

    em {
      font-style: italic;
    }

    s {
      text-decoration: line-through;
    }

    img {
      width: 100%;
    }

    ol {
      list-style: decimal;
    }

    ul {
      list-style: disc;
    }
  }

  .video {
    position: relative;
    width: 100%;
    max-width: 675px;
    height: 380px;
    margin: 0 auto 110px auto;

    ${mobile(css`
      position: relative;
      width: 100%;
      height: auto;
      padding-top: 54%;
      margin: 32px 0 10px 0;
    `)}

    .react-player {
      position: absolute;
      top: 0;
      left: 0;
    }
  }
`;

/**
 * AlertBanner는 v2 컴포넌트이고, 내부에 사용하고 있는 다른 sds-v2 컴포넌트가 많아서 사용하지 못하고 직접 스타일을 지정함
 */
const aiTranslationBanner = styled.div`
  margin-top: 16px;
  padding: 8px 16px;
  background-color: #5482d6;
  text-align: center;
  word-break: keep-all;

  /** sds-v2 스타일을 사용할 수 없어서 직접 스타일을 지정함 */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: -0.1px;
  color: #fff;

  ${mobile(css`
    margin-top: 0;
  `)}
`;

export default {
  container,
  aiTranslationBanner,
};
